import countries from 'iso-3166-1';

const CUSTOM_A3_TO_A2 = {
  MLV: 'FK',
};

export function getCountryId(geo) {
  return geo.id || geo.properties?.ISO_A3 || geo.properties?.iso_a3;
}

export function isoA3ToA2(isoA3) {
  if (!isoA3) return null;
  if (CUSTOM_A3_TO_A2[isoA3]) return CUSTOM_A3_TO_A2[isoA3];
  const entry = countries.whereAlpha3(isoA3);
  return entry?.alpha2 ?? null;
}

export function isoA2ToA3(isoA2) {
  if (!isoA2) return null;
  const entry = countries.whereAlpha2(isoA2);
  return entry?.alpha3 ?? null;
}

/** Resolve a map vote key (mock data uses ISO A2) from a geography ISO A3 id. */
export function resolveVoteKey(isoA3, countryVotes = {}) {
  if (!isoA3) return null;
  if (countryVotes[isoA3] !== undefined) return isoA3;

  const a2 = isoA3ToA2(isoA3);
  if (a2 && countryVotes[a2] !== undefined) return a2;

  return isoA3;
}

export function getCountryVote(isoA3, countryVotes = {}) {
  const key = resolveVoteKey(isoA3, countryVotes);
  return key ? countryVotes[key] : undefined;
}

export function getCountryName(geo) {
  return geo.properties?.name ?? geo.properties?.NAME ?? getCountryId(geo);
}
